import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getUserId } from '../../../redux/slices/userSlice'
import { paramsToQuery } from '../../../utils/historyDecorators'

import './styles.scss'

const MoneyBack = () => {
	const user_id = useSelector(getUserId)

	return (
		<div className="money-back">
			<div className="money-back__wrapper">
				<div className="money-back__wrapper__content">
					<h3 className="money-back__wrapper__content__title">
						100% money-back guarantee
					</h3>
					<p className="money-back__wrapper__content__text">
						<span className="money-back__wrapper__content__text__accent">
							14-day money back guarantee
						</span>
						, which entitles you to a full refund upon cancellation and emailing{' '}
						<a
							href="https://mail.google.com/mail/?view=cm&fs=1&to=support@refineapp.co"
							className="link"
							target="_blank"
							rel="noreferrer"
						>
							support@refineapp.co
						</a>{' '}
						to request a refund. Such refund requests must be made within the
						first 14 calendar days from your first date of payment. More about
						applicable limitations in our{' '}
						<Link
							className="money-back__wrapper__content__text__link"
							to={{
								pathname: '/money-back-policy',
								search: paramsToQuery({ user_id }),
							}}
						>
							Money-back Guarantee Policy
						</Link>
					</p>
				</div>
			</div>
			<img
				src="/images/sale/rosette.png"
				alt="Rosette."
				className="money-back__rosette"
			/>
		</div>
	)
}

export { MoneyBack }
